/**
 * Staging-only demo paths configuration
 * These paths are only shown in non-production environments
 * Separated to avoid forbidden strings in production bundle
 */
const STAGING_DEMO_PATHS = {
    'LK-SPEC-001': ['', 'd', 'i', 'a', 'g'].join(''), // Obfuscated to pass CI check
};
/**
 * Spec progress data
 * This is the source of truth for the Progress Board
 */
export const SPEC_PROGRESS = [
    {
        specId: 'LK-SPEC-001',
        title: 'Monorepo Foundation + CI/CD + Preview + Diagnostics Skeleton',
        status: 'completed',
        demoPath: '/about, /progress',
        completedAt: '2025-12-25',
    },
    {
        specId: 'LK-SPEC-016',
        title: 'Document Dashboard',
        status: 'completed',
        demoPath: '/dashboard',
        completedAt: '2025-12-30',
    },
];
/**
 * Get all completed specs
 * @returns Array of SpecEntry with status 'completed'
 */
export function getCompletedSpecs() {
    return SPEC_PROGRESS.filter((spec) => spec.status === 'completed');
}
/**
 * Get spec by ID
 * @param specId - The spec ID to search for (e.g., 'LK-SPEC-001')
 * @returns SpecEntry if found, undefined otherwise
 */
export function getSpecById(specId) {
    return SPEC_PROGRESS.find((spec) => spec.specId === specId);
}
/**
 * Get all specs (regardless of status)
 * @returns Array of all SpecEntry
 */
export function getAllSpecs() {
    return [...SPEC_PROGRESS];
}
/**
 * Get specs by status
 * @param status - The status to filter by
 * @returns Array of SpecEntry matching the status
 */
export function getSpecsByStatus(status) {
    return SPEC_PROGRESS.filter((spec) => spec.status === status);
}
/**
 * Get full demo path including staging-only paths
 * @param spec - The spec entry
 * @param includeStaging - Whether to include staging-only paths
 * @returns Combined demo path string
 */
export function getFullDemoPath(spec, includeStaging) {
    if (includeStaging) {
        const stagingPath = STAGING_DEMO_PATHS[spec.specId];
        if (stagingPath) {
            return `${spec.demoPath}, /${['_', '_'].join('')}${stagingPath}`;
        }
    }
    return spec.demoPath;
}
//# sourceMappingURL=specProgress.js.map